import React from 'react';
import axios from 'axios';
import config from '~/config';
import cookies from '~/services/cookies';
/*
Usage: Only use this for pages
*/
const withAutoLogin = () => (WrappedComponent) => {
  class Component extends React.Component {
    componentDidMount() {
      const { i18n } = this.props;
      let currentLang = i18n?.language === 'ja' ? 'jp' : i18n?.language;

      window.addEventListener('message', async (event) => {
        if (event.origin === config.ssoURL) {
          console.log('EVENT MESSAGE ===> ', { event });
          if (event.data) {
            let ssoTokenData = JSON.parse(event.data);
            const res = await axios.get(
              `${config.ssoURL}/get-session-user?globalSessionToken=${ssoTokenData.sso_logged}`,
            );
            if (res?.data?.sessionUser) {
              window.location.href = `${
                config.ssoURL
              }/login?lang=${currentLang}&serviceURL=${encodeURIComponent(
                window.location.href,
              )}&autoLogin=true`;
            } else {
              const iframe = document.getElementById('ssoAutoLoginIframe')
                .contentWindow;
              iframe.postMessage(
                JSON.stringify({ delete_sso_logged: ssoTokenData.sso_logged }),
                '*',
              );
            }
          }
        }
      });
    }

    render() {
      return (
        <>
          <WrappedComponent {...this.props} />
          {process.browser && (
            <iframe
              sandbox="allow-scripts allow-same-origin"
              width="0"
              height="0"
              style={{ display: 'none' }}
              id="ssoAutoLoginIframe"
              src={`${config.ssoURL}/share-auth?token=${
                cookies.get('sessionId') || ''
              }&from=${encodeURIComponent(window.location.href)}`}
              hidden
            ></iframe>
          )}
        </>
      );
    }
  }

  return Component;
};

export default withAutoLogin;
